
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { APIObserverService } from '../../_observerServices/API-Observer';
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { DataSource } from '@angular/cdk/table';
import { Observable } from 'rxjs/Observable';
import { Constants } from '../../../../_utils/Constants';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { formatDate } from '@angular/common';
import { saveAs as importedSaveAs } from "file-saver";
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import * as moment from 'moment-timezone';

@Component({
  selector: 'app-entity-obv',
  templateUrl: './entity-obv.component.html',
  styleUrls: ['./entity-obv.component.css']
})
export class EntityObvComponent implements OnInit {

  maxDate: Date = new Date();

  fileDownload: any = [];
  bookmarkArray: any = [""];

  dataSubject = new BehaviorSubject<any[]>([]);
  displayedColumns: string[] = ['entityId', 'name', 'category', 'noOfHeaders', 'noOfTemplates', 'approvedDate', 'address'];
  /*  'Uploaded By', */
  form1: any = {};
  fetchedData: any;
  data: any = {};
  noRecord: any;
  bookmark: any = "";
  pageIndex: number = 1;
  fdate: any;
  ldate: any;
  filterType: string = "all";
  param: any;
  operation: string = "default";
  Count: any;
  floredvalue: any;
  textField: string;
  openDropdown(value) {
    this.form1.searchBy2 = null
    if (value == "entityId")
      this.textField = "Entity ID"
    else if (value == "name")
      this.textField = "Entity Name"
    else if (value == "poi")
      this.textField = "PAN/TAN Number"
    else if (value == "category")
      this.textField = "Category"
    else
      this.textField = ""

    console.log("value", value)
    this.form1.searchBy2 = "";
    if (value == "category") {
      this.showDropdown = true;
    }

    else {
      this.showDropdown = false;
    }
    this.form1.search = null
  }
  reset() {
    this.pageIndex = 1
    this.data = {}
    this.APIgetEntitySummary("");
    this.filterType = "all"
    this.bookmarkArray = [""]
    // this.operation="default"
    this.textField = ""
    this.showDropdown = false;
    this.fdate = null
    this.ldate = null

  }
  onSubmitFilter(filterForm) {
    this.bookmark = ""
    this.bookmarkArray = [""];
    this.operation = "search";
    this.pageIndex = 1;
    this.fdate = filterForm.startDate;
    this.ldate = filterForm.endDate;

    var cdate = formatDate(Date.now(), 'yyyy-MM-dd', 'en-US');

    if (typeof this.fdate === 'undefined' || this.fdate == null)
      this.fdate = "";
    else
      this.fdate = formatDate(filterForm.startDate, 'yyyy-MM-dd', 'en-US');
    if (typeof this.ldate === 'undefined' || this.ldate == null)
      this.ldate = "";
    else
      this.ldate = formatDate(filterForm.endDate, 'yyyy-MM-dd', 'en-US');

    if (filterForm.searchBy == "category")
      this.param = filterForm.searchBy2
    else
      this.param = filterForm.search
    if ((filterForm.searchBy == null || filterForm.searchBy == undefined) && (this.param != undefined || this.param != null)) {
      this.$modal.errorModal({
        title: 'Entity Template Search',
        msg: 'Please select search by'
      });
      return;
    }

    if (typeof this.param === 'undefined' || this.param == null)
      this.param = "";



    if (filterForm.searchBy)
      this.filterType = filterForm.searchBy;
    if (this.fdate != "" && this.ldate == "") {
      this.ldate = cdate
    }


    if ((!filterForm.endDate && !filterForm.search && !filterForm.searchBy && !filterForm.startDate) || filterForm.searchBy == "" && !filterForm.startDate) {
      this.$modal.errorModal({
        title: 'Error',
        msg: 'Please search by valid criteria'
      });
    }
    else if ((this.filterType != null && this.filterType != "" && this.filterType != "all") && (this.param == null || this.param == "")) {

      this.$modal.errorModal({
        title: 'Error',
        msg: 'Please provide ' + this.textField + ' value'
      });
    }
    else if (this.fdate == "" && this.ldate == "" && (this.filterType == null || this.filterType == "") && this.param == "") {
      this.$modal.errorModal({
        title: 'Error',
        msg: 'Please select any option'
      });
    }
    else if (this.fdate > this.ldate) {
      this.$modal.errorModal({
        title: 'Error',
        msg: 'From Date cannot be after To Date'
      });
    }
    else if (this.fdate == "" && this.ldate != "") {
      this.$modal.errorModal({
        title: 'Error',
        msg: 'Please select Start date'
      });
    }
    else {
      this.searchFunction('')
    }
  }


  searchFunction(bookmark) {
    this.data = {

      "Start_Date": this.fdate,
      "End_Date": this.ldate,
      "filterType": this.filterType,
      "bookmark": bookmark,
      "size": "10",
      "param": this.param
    }
    this.obv.searchEntityDataForObserver(this.data)
      .subscribe(r => {
        this.bookmark = r.bookmark
        this.Count = r.Count
        this.floredvalue = Math.ceil(this.Count / 10)
        this.dataSource = r.Result;
        this.onChangeDataSource(r.Result);
      });
  }
  onChangeDataSource(value) {
    this.dataSubject.next(value);
    this.dataSource = new MatTableDataSource();

    this.dataSource = new MatTableDataSource(value);
    this.dataSource.paginator = this.paginator;
    //  this.noRecord = this.dataSource.connect().pipe(map(data => data.length === 0));

    console.log("dataSource : ", this.dataSource);
  }

  public Entity_ID: any;

  dataSource: any;

  form: any = {};
  showDropdown: boolean = false



  startDate1: any;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  @ViewChild(MatSort) sort: MatSort;
  constructor(
    private obv: APIObserverService,
    private db: $DBManagerService,
    private fb: FormBuilder,
    private $modal: $ModalManagerService,
  ) {


  }

  ngOnInit() {


    this.APIgetEntitySummary("");
    // this.dataSource.sort = this.sort;

    console.log(this.startDate1)
    this.maxDate.setDate(new Date().getDate());

  }
  APIgetEntitySummary(bookmark) {

    var data = {
      'bookmark': bookmark
    }
    this.obv.getEntityDataForObserver(data).subscribe({
      next: value => {

        this.dataSubject.next(value);
        this.bookmark = value.bookmark
        this.Count = value.Count
        this.floredvalue = Math.ceil(this.Count / 10)

        this.dataSource = new MatTableDataSource(value.Result);
        this.dataSource.sort = this.sort;
        console.log("dataSource : ", this.dataSource);
      }
    });
  }
  previous() {
    this.pageIndex--;
    if (this.operation == "default")
      this.APIgetEntitySummary(this.bookmarkArray[this.pageIndex - 1])
    else if (this.operation == "search")
      this.searchFunction(this.bookmarkArray[this.pageIndex - 1])
  }
  next() {
    this.bookmarkArray.push(this.bookmark)
    this.pageIndex++

    if (this.operation == "default")
      this.APIgetEntitySummary(this.bookmark)
    else if (this.operation == "search")
      this.searchFunction(this.bookmark)
  }

  getDate(epocDate) {
    var returnedValue = ""
    if (epocDate == "") {
      returnedValue = ""
    }
    else if (isNaN(epocDate)) {
      returnedValue = epocDate  //dd/MM/yyyy HH:mm:ss
    }
    else {
      returnedValue = moment.unix(epocDate).tz('Asia/Kolkata').format('DD/MM/YYYY HH:mm:ss')
    }
    return returnedValue
  }
  downloadentityworklistcsvfile() {
    this.data = {

      "Start_Date": this.fdate,
      "End_Date": this.ldate,
      "filterType": this.filterType,
      "bookmark": "",
      "size": "100000",
      "param": this.param
    }
    let now = new Date();
    var fileName;
    const currentdat = formatDate(now, 'medium', 'en-US', '+0530');
    this.obv.downloadEntityDataForObserver(this.data).subscribe(r => {
      fileName = currentdat + '_Active Entity.csv';
      importedSaveAs(r, fileName)
      //  this.downloadFile(r, Batch_Id);
      this.$modal.successModal({
        title: 'Entity Summary',
        msg: 'File has been downloaded Successfully'
      });
    })

  }

}